var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { setWorkspaceEventService } from 'src/reducers/workspaceEvent/actions';
import SelectRound from './SelectRound';
import ListTeams from './ListTeams';
import ListAthletes from './ListAthletes';
import AlertSelectRoundPrompt from './AlertSelectRoundPrompt';
var Scoreboard = (function (_super) {
    __extends(Scoreboard, _super);
    function Scoreboard(props) {
        var _this = _super.call(this, props) || this;
        _this.subscriber = {};
        return _this;
    }
    Scoreboard.prototype.componentWillReceiveProps = function (nextProp) {
        var currProp = this.props;
        if (nextProp.scoreboard.roundId &&
            nextProp.scoreboard.roundId !== currProp.scoreboard.roundId) {
            this.unsubscribeToAthleteScoreRoute();
            this.subscribeToAthleteScoreRoute(nextProp.scoreboard.roundId);
        }
    };
    Scoreboard.prototype.subscribeToAthleteScoreRoute = function (roundId) {
        var _this = this;
        var searchQuery = {
            query: {
                roundId: roundId,
                eventId: this.props.workspaceEvent.event.id,
                $limit: 10000,
                $sort: { id: 1 },
            },
        };
        this.subscriber.athleteScoreRoutes = feathersClient.service('athleteScoreRoutes')
            .watch()
            .find(searchQuery)
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceEventService('athleteScoreRoutes', res));
        });
    };
    Scoreboard.prototype.unsubscribeToAthleteScoreRoute = function () {
        if (this.subscriber.athleteScoreRoutes) {
            this.subscriber.athleteScoreRoutes.unsubscribe();
        }
    };
    Scoreboard.prototype.render = function () {
        return (React.createElement("div", { id: 'wrapper-scoreboard' },
            React.createElement(SelectRound, null),
            !this.props.workspaceEvent.category || !this.props.workspaceEvent.round
                ? React.createElement(AlertSelectRoundPrompt, null)
                : this.props.workspaceEvent.category.isTeamCategory
                    ? React.createElement(ListTeams, { isPlatform: this.props.isPlatform })
                    : React.createElement(ListAthletes, { isPlatform: this.props.isPlatform })));
    };
    return Scoreboard;
}(React.Component));
var mapStateToProps = function (state) { return ({
    scoreboard: state.scoreboard,
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        category: state.workspaceEvent.categories && state.workspaceEvent.categories.data.find(function (c) { return c.id === state.scoreboard.categoryId; }),
        round: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data.find(function (r) { return r.id === state.scoreboard.roundId; }),
    },
}); };
export default connect(mapStateToProps)(Scoreboard);



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/index.tsx
// module id = 987
// module chunks = 0